export enum ButtonType {
  FLAT,
  NORMAL,
}

export enum ControlButton {
  CLOSE = "CLOSE",
  MINIMIZE = "MINIMIZE",
  MAXIMIZE = "MAXIMIZE",
  ICON = "ICON",
}

export enum MenuCheckButtonType {
  CHECK = "CHECK",
  RADIO = "RADIO",
}

export enum EntryPosition {
  LEFT = "LEFT",
  CENTER = "CENTER",
  RIGHT = "RIGHT",
}

export enum WrapMode {
  NONE = "NONE",
  WORD = "WORD",
  CHAR = "CHAR",
  WORD_CHAR = "WORD_CHAR",
}

export enum MouseButton {
  LEFT = 1,
  MIDDLE = 2,
  RIGHT = 3,
  BTN_4 = 4,
  BTN_5 = 5,
  BTN_6 = 6,
  BTN_7 = 7,
  BTN_8 = 8,
  BTN_9 = 9,
  BTN_10 = 10,
}

export enum KeyPressModifiers {
  NONE = "NONE",
  SHIFT = "SHIFT",
  CTRL = "CTRL",
  ALT = "ALT",
  CTR_ALT = "CTRL_ALT",
  SHIFT_ALT = "SHIFT_ALT",
  SHIFT_CTRL = "SHIFT_CTRL",
  SHIFT_CTR_ALT = "SHIFT_CTR_ALT",
}
